module.exports = __webpack_public_path__ + "img/page_not_found.2ed90f04.png";